<template>
  <div class="result-box">
    <div class="result-main">
      <div class="step-box">
        <div class="item">
          <img src="@/assets/images/open-result-icon-step-01.png" class="icon1">
          <p class="text">{{ $t('openAccount.t000034') }}</p>
          <span class="shape active"></span>
        </div>
        <div class="item">
          <img src="@/assets/images/open-result-icon-step-02.png" class="icon2">
          <p class="text">{{ $t('openAccount.t000035') }}</p>
          <span class="shape" :class="{active: result.account_status == 4 ||result.account_status == 5}"></span>
        </div>
        <div class="item">
          <img src="@/assets/images/open-result-icon-step-03.png" class="icon3">
          <p class="text" :class="{active: result.account_status == 1}">{{ $t('openAccount.t000036') }}</p>
          <span class="shape"></span>
        </div>
      </div>
      <div class="main">
        <img src="@/assets/images/id-card-upload-success.png" class="icon light">
        <img src="@/assets/images/id-card-upload-success-dark.png" class="icon dark">
        <p class="title">{{ $t('openAccount.t000037') }}</p>
        <p class="sub">
          <template v-if="result.account_status == 4 ||result.account_status == 5">
            {{ $t('openAccount.t000038') }}
          </template>
          <template v-if="result.account_status == 1">
            {{ $t('openAccount.t000039') }}
          </template>
        </p>
        <a class="btn" @click="openApp">{{ $t('openAccount.t000040') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";

export default {
  props: {
    result: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data(){
    return {

    }
  },
  methods: {
    openApp(){
      const openURL = 'gf://com.lhy.gf';
      window.open(openURL,'_blank');
      try {
        setTimeout(async ()=>{
          const data = await this.$apis.getDownUrl();
          const { android_download_url, ios_download_url } = data;
          const downLoadURL = getBrowser().isIos ? ios_download_url : android_download_url;
          window.open(downLoadURL, '_blank')
        },200)
      }catch (err){

      }
    }
  }
}
</script>

<style scoped lang="less">
.black-theme{
  .result-box{
    background: #1B1C24;
    .result-main{
      .main{
        background: #262830;
        .icon{
          &.light{
            display: none;
          }
          &.dark{
            display: block;
          }
        }
        .title,.sub{
          color: #fff;
        }
        .btn{
          background: #377CFB;
        }
      }
    }
  }
}
.result-box{
  min-height: 100vh;
  background: #F9FAFC;
  .result-main{
    padding: 64px 0 100px;
    background: linear-gradient(
      to bottom,
      #17161C 0%,
      #17161C 20%,
      rgba(23, 22, 28, 0.6) 40%,
      rgba(23, 22, 28, 0) 60%,
      rgba(23, 22, 28, 0) 100%
    );
    .step-box{
      display: flex;
      position: relative;
      .item{
        z-index: 3;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 46px;
        justify-content: flex-end;
        position: relative;
        .icon1{
          width: 70px;
          height: 52px;
        }
        .icon2{
          width: 68px;
          height: 62px;
        }
        .icon3{
          width: 56px;
          height: 62px;
        }
        .text{
          margin-top: 20px;
          color: #fff;
          font-size: 28px;
          font-weight: 500;
        }
        .shape{
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 24px;
          height: 24px;
          margin-left: -12px;
          background: url("../../../../assets/images/open-result-icon-step-no.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 50%;
          &.active{
            background: url("../../../../assets/images/open-result-icon-step-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      &:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 11px;
        width: 100%;
        height: 1px;
        background: rgba(255,255,255,0.40);
      }
    }
    .main{
      margin: 40px 32px 0;
      padding: 104px 60px 120px;
      background: #fff;
      border-radius: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon{
        width: 120px;
        height: 120px;
        &.dark{
          display: none;
        }
      }
      .title{
        margin-top: 60px;
        font-size: 40px;
        line-height: 52px;
        color: #17161C;
        font-weight: 500;
      }
      .sub{
        margin-top: 11px;
        line-height: 52px;
        font-weight: 32px;
      }
      .btn{
        margin-top: 95px;
        width: 100%;
        height: 104px;
        border-radius: 104px;
        background: #17161C;
        color: #fff;
        font-size: 32px;
        line-height: 104px;
        text-align: center;
      }
    }
  }

}
</style>
